var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.frontpage = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	//$('.children', '#mMenu ').prepend('<a class="expand" href="#"><span>+</span></a>');
	site.nav.bind();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
		if ($('#menuContent').is(':empty')){
			site.menu.loadNews([1]);
		}
		location.hash = 'menu';
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
		history.pushState("", document.title, window.location.pathname); //remove hash
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});
	$menu.append($html);
};

site.frontpage.init = function() {
	if (!isFront()) return;

	$('#hero li').each(function () {
		var bc = $(this);
		bc.html(bc.html().replace(/\|/g,'<span class=\"pipe\">|</span>'));
	});

	site.frontpage.height();
	site.frontpage.bars();
	site.frontpage.sideNavInit();
	site.frontpage.scrollreveal();

	$('.scroll', '.hero').on('click', function() {
		var scrollTo = $('.box_ord_2');

		$('html,body').animate({
			scrollTop: scrollTo.offset().top
		},1000)
	});

	$('.elm_emailAddress label, .elm_text label, .elm_textarea label','#box_custom_18').inFieldLabels();

	$secondFormBox = $('#box_custom_26');
	// Change ids and for values for the second form
	$.each($('label', $secondFormBox), function() {
		$(this).attr('for', $(this).attr('for') + '2');
	});

	$.each($('input[id="text"], input[id="emailAddress"], input[id="mailinglist"], textarea[id="textarea"]', $secondFormBox), function() {
		$(this).attr('id', $(this).attr('id') + '2');
	});

	/*$form = $secondFormBox.find('form');
	$form.attr('id', $form.attr('id') + '2');*/

	$('.elm_emailAddress label, .elm_text label, .elm_textarea label', $secondFormBox).inFieldLabels();
};

site.frontpage.sideNavInit = function() {
	$sidenav = $('<nav id="sidenav" role="navigation">');
	$sidenavul = $('<ul class="nav"></ul>');

	$.each($('> .box', '#main'), function(key, value) {
		$box = $(this);
		if ($box.find('.hero').length == 0) {
			$title = '<span>' + $box.find('h3').text() + '</span>';
			$link = '<li class="item"><a href="#' + $box.attr('id') + '">' + $title + '</a></li>';
			$sidenavul.append($link);
		}
	});

	$('body').append($sidenav.append($sidenavul)).scrollspy({ target: '#sidenav', offset: 200 });
	site.frontpage.sideNavMultipleSelected();
	$('body').on('activate.bs.scrollspy', site.frontpage.sideNavMultipleSelected);

	$('a', '#sidenav').on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({scrollTop: $($(this).attr('href')).offset().top}, 1000);
	});
};

site.frontpage.sideNavMultipleSelected = function() {
	// If there are two boxes side by side both items in navigation should be active.
	var $currNav = $('.active', '#sidenav');
	var activeBoxId = $currNav.find('a').attr('href');

	var $currBox = $(activeBoxId);
	var $prevBox = $currBox.prev();

	if($currBox.length && $prevBox.length && $currBox.offset().top == $prevBox.offset().top) {
		$currNav.prev().addClass('active');
	}
};

site.frontpage.bars = function() {
	// Set height for all bars based on ratio of the highest bar
	$.each($('.box_extras_category'), function(key, value) {
		$bars = $('.bars', $(value));

		var values = $(".bar", $bars).map(function(){
			return parseInt($(this).attr("data-value"), 10);
		}).get();

		var maxValue = Math.max.apply(Math, values);

		$.each($('.item', $bars), function(key, item) {
			$item = $(item);
			$value = $item.find('.value');
			$bar = $item.find('.bar');

			$percentage = ($bar.attr('data-value') / maxValue) * 100;
			$bar.css('height', $percentage + "%");

			window.setTimeout(null, 1000);
		});
	});
};

site.frontpage.scrollreveal = function() {
	window.sr = ScrollReveal();

	// Reveal doesn't want a jQuery selector and doesn't
	// work properly if we use .stevda.promo h3, .stevda.promo .txt as selector

	/*$.each($('.strevda.promo'), function() {
		var id = $(this).parents('.box_advert_advert').attr('id');
		var scrollSelector = "#" + id + " h3, #" + id + " .txt";
		sr.reveal(scrollSelector, {
			scale: 1,
			distance: "100px",
			origin: "left",
			duration: 1000
		}, 200);
	});*/

	// Car and people
	sr.reveal('#box_advert_advert_11 .image img, #box_advert_advert_20 .image img', {
		scale: 1,
		distance: "150px",
		origin: "right",
		duration: 1000,
		opacity: 0
	});

	// Plane
	sr.reveal('#box_advert_advert_19 .image img', {
		scale: 1,
		distance: "150px",
		origin: "left",
		duration: 1000,
		opacity: 0
	});

	// Helment
	sr.reveal('#box_advert_advert_25 .image img', {
		scale: 1,
		distance: "150px",
		origin: "bottom",
		duration: 1000,
		opacity: 0
	});

	// Bar chart 1
	sr.reveal('#box_extras_category_13 .item .bars > .item', {
		duration: 700,
		scale: 0.6
	}, 150);

	// Bar chart 2
	sr.reveal('#box_extras_category_16 .item .bars > .item', {
		duration: 700,
		scale: 0.6
	}, 150);
};

site.frontpage.height = function() {
	if (!$('body').hasClass('frontpage')) return;
	$('#hero li').css('min-height',0);
	var h = $(window).height() - ($('#header').height());
	//h = (h < 800) ? h : 800;
	$('#hero li').css('min-height',h);
};

/**
 * News
 */
site.news = {
	init: function () {
		if (!$('body').hasClass('news')) return;
		$(".entryContent img").each(function() {
			$(this).wrap('<div class="image"></div>');
			$(this).parent().append('<span>'+$(this).attr('title')+'</span>');
			$(this).attr('title','');
		});
	}
};

/**
 * Search
 */
site.search = {
	init: function() {
		if ($('body').hasClass('search')) {
			$('body').addClass('search-open');
			$('#filter li').removeClass('selected');
		}
		site.search.toggle();
	},
	toggle: function() {
		$('#searchToggle').click(function(e) {
			if (!$('body').hasClass('search-open')) {
				$('body').addClass('search-open');
				$('#searchToggle #q').focus();
				$('#filter li').removeClass('selected');
			}
		});
	}
};

/**
 * Menu
 */
site.menu = {
	init: function() {
		//load more button
		$(document).on('click', '#loadMore', function(e) {
			$(this).parents('.footer').addClass('loading').removeClass('more');
			var cat = $(this).parents('.category').data('cat');
			var offset = $(this).parents('.category').data('offset');
			site.menu.loadNews([cat,offset]);
		});
	},
	loadNews: function(options) {
		var cat = options[0];
		var offset = (options[1]) ? options[1] : 1;
		if (offset == 1) {
			$('#menuContent').empty();
		}

		$.ajax({
			url: '/_/moya/html/index/news/'+cat+'/'+offset,
			dataType:'json',
			success: function(r) {
				$.each(r.categories, function(i, c) {
					if (r.init) {
						$('#menuContent').append(c.data);
					}
					else {
						$('.cat'+i+' .entries','#menuContent').append(c.data);
					}
					if (c.more) {
						$('.cat'+i,'#menuContent').data("offset",offset+1);
						$('.cat'+i+' .footer','#menuContent').addClass('more')
					}
				});
				$('.footer','#mainmenu').removeClass('loading');
				$("#menuContent .entry").each(function() {
					var $this = $(this);
					$this.click(function() {
						location.href = $("h3 a",this).attr("href");
					});
				});

				setTimeout(function() {
				$('#menuContent .entry.loading').addClass('loaded').removeClass('loading');
				},10);
			}
		});
	}
};


site.faq = {
	init : function() {
		var $faq = $('#faq');
		if ($faq.length == 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});
	}
};

function isFront() {
	return $('body').is('.frontpage');
}

function isValidEmailAddress(emailAddress) {
	var pattern = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
	return pattern.test(emailAddress);
}

function isValidForm($frm) {
	var name = $frm.find('.elm_text input[type="text"]').first().val();
	var email = $frm.find('.elm_emailAddress input[type="text"]').val();
	return name.length != 0 && isValidEmailAddress(email);
}

function resetForm($frm) {
	$frm.find('.elm_text input[type="text"]').first().val('');
	$frm.find('.elm_emailAddress input[type="text"]').val('');
	$frm.find('.elm_textarea textarea').val('');
	$frm.find('.errors').remove();
}

// Run all the inits \o/
$(function() {
	site.nav.init();
	site.frontpage.init();
	site.news.init();
	site.search.init();
	site.menu.init();
	site.faq.init();

	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);
	$(window).on('load', function () {
		$(document.body).addClass('domready');
	});

	$forms = [
		$('.frontpage #moya_form_hvad-viltu-vita-um-alidnadinn'),
		$('.frontpage #moya_form_hvad-viltu-vita-um-alidnadinn-2')
	];

	$($forms).each(function() {
		$(this).on('submit', function (ev) {
			$frm = $(this);
			if (isValidForm($frm)) {
				$.ajax({
					type: $frm.attr('method'),
					url: $frm.attr('action'),
					data: $frm.serialize(),
					success: function (data) {
						$('.frontpage .moya_form').each(function() {
							resetForm($(this));
						});
						bootbox.alert("<p><strong>Takk fyrir spurninguna!</strong></p><p>Við sendum þér tölvupóst um leið og henni hefur verið svarað.</p>");
					}
				});
				ev.preventDefault();
			}
		});
	});

}(Zepto));

$(window).resize(function () {
	site.frontpage.height();
});

$(function() {
	$(window).bind( "hashchange", function(e) {
		var h = location.hash;

		//No hash. Close menu if open
		if (h == '') {
			 if ($('body').hasClass('mainmenu-open')) {
			 	$('#mainmenuToggle').trigger('click');
			 }
		}
		else {
			//For #menu or #catX - open menu if closed
			if (h == '#menu' || h.substr(1,3)=='cat') {
				if (!$('body').hasClass('mainmenu-open')) {
					$('#mainmenuToggle').trigger('click');
				}
			}

			//Load new category
			if (h.substr(1,3)=='cat') {
				var cat = h.substr(4, h.length);
				site.menu.loadNews([cat]);

				$('li','#filter').removeClass('selected');
				var filterItem = '#filter .'+h.substr(1, h.length);
				$(filterItem).parent().addClass('selected');
			}
		}
	});
	$(window).trigger( "hashchange" );

	$('input[name=news_imagetext]').removeAttr('maxlength');
});
